
import { defineComponent, ref, reactive, watch, nextTick, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

import Swiper from 'swiper/swiper-bundle'
import 'swiper/swiper-bundle.min.css'

import COVERAPP from '@/utils/COVERAPP'

export default defineComponent({
    setup (props, context) {
        const $store = useStore()
        const $router = useRouter()
        const list = $store.state.picViewerData.list
        let picSiwper: any = null
        const curIndex = ref<number>($store.state.picViewerData.index || 0)
        const isBig = ref<boolean>(false)
        const isLeaving = ref<boolean>(false)

        const initSwiper = () => {
            picSiwper = new Swiper('.picture-viewer-wrapper .swiper', {
                loop: true,
                zoom : true,
                initialSlide: curIndex.value,
                on: {
                    slideChangeTransitionStart () {
                        if (picSiwper && picSiwper.zoom) {
                            picSiwper.zoom.out()
                        }
                        picSiwper && (curIndex.value = picSiwper.realIndex)
                    },
                    zoomChange (swiper, scale: number) {
                        isBig.value = scale != 1
                    }
                }
            })
        }

        const prev = () => {
            picSiwper.slidePrev()
        }

        const next = () => {
            picSiwper.slideNext()
        }

        const scaleToggle = () => {
            picSiwper.zoom.toggle()
        }

        const close = () => {
            isLeaving.value = true
        }

        const destroy = () => {
            if (!isLeaving.value) return
            $store.commit('SET_PICVIEWERDATA', null)
        }

        onBeforeUnmount(() => {
            picSiwper.destroy()
        })

        onMounted(() => {
            initSwiper()
        })    

        return {
            list,
            curIndex,
            isBig,
            isLeaving,
            prev,
            next,
            scaleToggle,
            close,
            destroy
        }
    }
})
